import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DebitNote, DebitNoteCreate, DebitNoteFilter } from '../data/debitNote';

export function createDebitNoteService(client: AxiosInstance) {
  return createCrudService<DebitNote, DebitNoteCreate, DebitNoteFilter>(
    client,
    '/sales/DebitNote',
    'id',
  );
}

export type DebitNoteService = CrudService<DebitNote, DebitNoteCreate, DebitNoteFilter>;
